import React from 'react';
import Disclosure from './components/Disclosure';
import Heading from './components/Heading'
import InputCard from './components/InputCard';
import Results from './components/Results';
import Footer from './components/Footer';

class App extends React.Component {

  constructor (props) {
    super(props);
    this.state = {step: -1, advancedMode: -1, modeSetLocation: -1, responses: {}, source: require("./data/source.json")};
  }

  stepForward = () => {
    this.setState(state => {
      if (state.step === -1 || state.source[state.step].userInfoID in state.responses) {
        if (state.advancedMode > -1 && (state.modeSetLocation === -1 || state.modeSetLocation === state.step)) {
          return {step: state.step + 1, modeSetLocation: state.step}
        }
        return {step: state.step + 1}
      }
    })
  }

  stepBackward = () => {
    this.setState(state => {
      var newResponses = state.responses
      delete newResponses[state.source[state.step].userInfoID]
      if (state.step === state.modeSetLocation) {
        return {step: state.step - 1, responses: newResponses, modeSetLocation: -1, advancedMode: -1} 
      }
      return {step: state.step - 1, responses: newResponses}
    })
  }

  setResponse = (response, type) => {
    this.setState(state => {
      var newResponses = state.responses
      newResponses[state.source[state.step].userInfoID] = response
      if (state.source[state.step].inputDescription && state.source[state.step].selectDescription && (state.modeSetLocation === -1 || state.modeSetLocation === state.step)) {
        return {responses: newResponses, advancedMode: type}
      }
      return {responses: newResponses}
    })
  }

  deleteResponse = () => {
    this.setState(state => {
      var newResponses = state.responses
      delete newResponses[state.source[state.step].userInfoID]
      return {responses: newResponses}
    })
  }

  restartAssessment = () => {
    this.setState(state => {
      return {step: -1, advancedMode: -1, modeSetLocation: -1, responses: {}}
    })
  }

  render() {
    console.log(this.state.responses)
    // console.log(this.state.modeSetLocation + " " +this.state.advancedMode)
    let AppContent;
    console.log(this.state.step);
    if (this.state.step === -1) {
      AppContent = <Disclosure onClick={this.stepForward.bind(this)}></Disclosure>
    } else if (this.state.step === this.state.source.length) {
      AppContent = <Results restartAssessment={this.restartAssessment.bind(this)} binaryChoice={this.state.advancedMode === 1 ? true : false} responses={this.state.responses}></Results>
    } else {
      AppContent = <InputCard setResponse={this.setResponse.bind(this)} deleteResponse={this.deleteResponse.bind(this)} stepForward={this.stepForward.bind(this)} stepBackward={this.stepBackward.bind(this)} state={this.state}></InputCard>;
    }
    return (
      <div>
        <Heading></Heading>
        <div class="container-md">
          <div class="mx-lg-5 p-md-3 p-lg-2 my-5 py-lg-5">
            {AppContent}
          </div>
        </div>
        <Footer></Footer>
      </div>
    );
  }  
}

export default App;
